import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16.577 20L10.81 14.234C8.65387 15.6564 5.77106 15.2164 4.13737 13.2155C2.50369 11.2147 2.64914 8.30213 4.47405 6.474C6.30186 4.64839 9.21475 4.50231 11.216 6.13588C13.2173 7.76946 13.6576 10.6526 12.235 12.809L18 18.576L16.577 20ZM8.03405 7.01399C6.5933 7.01308 5.35253 8.03002 5.07053 9.4429C4.78854 10.8558 5.54386 12.2711 6.87457 12.8234C8.20529 13.3756 9.74079 12.9109 10.542 11.7135C11.3433 10.5161 11.1871 8.91946 10.169 7.9C9.6043 7.33134 8.83549 7.0123 8.03405 7.01399ZM19 11H17V9H15V7H17V5H19V7H21V9H19V11Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SearchSmallPlus"
);
